const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue,
  mutateContentValue = _require.mutateContentValue;
const _require2 = require('./shared/dateDiff'),
  dateDiffInSeconds = _require2.dateDiffInSeconds;
const convertDurationToString = duration => {
  if (duration === undefined) {
    return '';
  }
  const hours = Math.floor(duration / 3600, 10);
  let minutes = "".concat(parseInt(duration / 60 % 60, 10));
  if (minutes < 10) {
    // add leading zero.  Kinda goofy - converting to string,
    // but works fine.
    minutes = "0".concat(minutes);
  }
  return "".concat(hours.toFixed(0), ":").concat(minutes);
};
/**
  * @function evalute - evaluate mbdWriteTotalsBehavior
  */

const evaluate = async (source, content
// parentContentPath,
// transientContext,
// nativeFunctions,
// sourceEvaluator,
) => {
  const absolutePath = source.absolutePath,
    _source$writeNumberOf = source.writeNumberOfBarges,
    writeNumberOfBarges = _source$writeNumberOf === void 0 ? true : _source$writeNumberOf,
    _source$writeTotalUnl = source.writeTotalUnloadTime,
    writeTotalUnloadTime = _source$writeTotalUnl === void 0 ? true : _source$writeTotalUnl,
    _source$options = source.options,
    options = _source$options === void 0 ? [] : _source$options;
  const collection = getContentValue(absolutePath, content);

  // if the collection is not defined, don't operate on it
  if (collection === undefined) return content;
  const collectionIDs = Object.keys(collection);
  const barges = {};
  const durations = {};
  collectionIDs.forEach(id => {
    const activity = collection[id];
    // calculate duration
    const startTime = activity.startTime,
      stopTime = activity.stopTime;
    if (startTime !== undefined && stopTime !== undefined) {
      const duration = dateDiffInSeconds(activity.stopTime, activity.startTime);
      // change to minutes.
      // eslint-disable-next-line no-param-reassign
      activity.duration = duration;
    } else {
      // start/stop time not set, should delete.
      delete activity.duration;
    }
    activity.stringDuration = convertDurationToString(activity.duration);
    const bargeLoadNumber = activity.bargeLoadNumber,
      timeAllocation = activity.timeAllocation,
      duration = activity.duration;
    if (bargeLoadNumber !== undefined) {
      barges[bargeLoadNumber] = (barges[bargeLoadNumber] || 0) + 1;
    }
    if (timeAllocation !== undefined && duration !== undefined) {
      const identifier = Object.keys(timeAllocation)[0];
      durations[identifier] = (durations[identifier] || 0) + duration;
    }
  });
  const totalBarges = Object.keys(barges).length;

  // rewrite the collection.
  mutateContentValue(absolutePath, content, collection);
  const bargesPath = '/dailyDredgeActivityLogSection/numberOfBarges';
  if (writeNumberOfBarges) {
    mutateContentValue(bargesPath, content, totalBarges);
  }
  const writeContentForPaths = identifier => {
    const value = durations[identifier] || null;
    if (!options.some(opt => opt.identifier === identifier)) {
      return;
    }
    const targetContentPath = "/dailyDredgeActivityLogSection/".concat(identifier, "Duration");
    mutateContentValue(targetContentPath, content, convertDurationToString(value));
  };
  writeContentForPaths('repair');
  writeContentForPaths('standby');
  writeContentForPaths('maintenance');
  writeContentForPaths('discharge');
  writeContentForPaths('debris');
  writeContentForPaths('dredging');
  writeContentForPaths('waitingForBarge');
  writeContentForPaths('standbyForVessel');
  writeContentForPaths('standbyForWeather');
  let totalUnloadDuration = 0;
  if (durations.discharge !== undefined && durations.debris !== undefined) {
    totalUnloadDuration = durations.discharge - durations.debris;
  }
  const totalUnloadDurationPath = '/dailyDredgeActivityLogSection/totalUnloadTime';
  if (writeTotalUnloadTime) {
    mutateContentValue(totalUnloadDurationPath, content, convertDurationToString(totalUnloadDuration));
  }
  const averageUnloadDurationPath = '/dailyDredgeActivityLogSection/avgUnloadTime';
  if (totalUnloadDuration !== 0 && totalBarges !== 0) {
    mutateContentValue(averageUnloadDurationPath, content, convertDurationToString(totalUnloadDuration > 0 ? Math.round(totalUnloadDuration / totalBarges) : 0));
  }
  const hasDischarge = options.some(opt => opt.identifier === 'discharge');
  const averageDischargeDurationPath = '/dailyDredgeActivityLogSection/averageDischargeTime';
  if (hasDischarge) {
    mutateContentValue(averageDischargeDurationPath, content, convertDurationToString(durations.discharge && totalBarges ? Math.round(durations.discharge / totalBarges) : null));
  }
  const hasDredge = options.some(opt => opt.identifier === 'dredging');
  const averageLoadDurationPath = '/dailyDredgeActivityLogSection/averageLoadTime';
  if (hasDredge) {
    mutateContentValue(averageLoadDurationPath, content, convertDurationToString(durations.dredging && totalBarges ? Math.round(durations.dredging / totalBarges) : null));
  }
  return content;
};
module.exports = {
  evaluate
};